import React from "react"
import ConfigurationProvider from "./configuration_provider"
import QuizModeSelectorContent from "./quiz_mode_selector_content"

function QuizModeSelector({
  title,
  quiz,
  cta,
  on_click,
  initial_quiz_mode,
  exam_conditions
}) {
  if (!quiz) return null

  return (
    <ConfigurationProvider
      quiz={quiz}
      quiz_mode={initial_quiz_mode}
      exam_conditions={exam_conditions}
    >
      <QuizModeSelectorContent {...{on_click, quiz, title, cta}}/>
    </ConfigurationProvider>
  )
}

export default QuizModeSelector
